import { useEffect, useState } from 'react';
import { NavigateFunction } from 'react-router-dom';
import Swal, {SweetAlertIcon} from 'sweetalert2';
// @ts-ignore
import LoadingOverlay from 'react-loading-overlay';

// Apis
import {getSavedApi} from '../../api/saves';

// Components
import NewsList from '../News/List';

// Context
import { useAuthStore } from '../../context/Auth';
import { useTranslationStore } from '../../context/Translation';

// Enums
import { CategoryTypes } from '../../enums/Categories';
import { LanguageResource } from '../../enums/Languages';
import { SwalIcons, SwalTitle } from '../../enums/Swal';

// Interfaces
import { NewsInterface } from '../../interfaces/News';

// Styles
import './index.scss';

interface PropsInterface {
  navigate: NavigateFunction,
}

const ProfileNews = (props: PropsInterface) => {
  const [loadingNewsSaved, setLoadingNewsSaved] = useState<boolean>(true),
    [savedNews, setSavedNews] = useState<NewsInterface[]>([]),
    [authState] = useAuthStore(),
    [t] = useTranslationStore();

  useEffect(() => {
    loadNews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState.token]);

  const loadNews = () => {
    getSavedApi(
      {
        token: authState.token,
        type: CategoryTypes.News,
      },
      (err: any, res: NewsInterface[]) => {
        if (err) {
          Swal.fire({
            icon: SwalIcons.Error as SweetAlertIcon,
            title: t(SwalTitle.Error),
            text: err,
          });
        } else {
          setSavedNews(res);
        }
        setLoadingNewsSaved(false);
      },
    );
  };

  return (
    <LoadingOverlay
      active={loadingNewsSaved}
      spinner
    >   
      <div className='my-list-wrapper'>
        <p className='text-weight-bold text-size-large my-list-sub-title-wrapper'>{t(LanguageResource.Profile + ':news_saved')}</p>
        <NewsList 
          news={savedNews}
          amount={0}
          limit={0}
          setLimit={() => {}}
          navigate={props.navigate}
        />
      </div>
    </LoadingOverlay>
  );
};

export default ProfileNews;
